export const categories = [
    { id: 1 , type:'Data Base Management System', faculty:'Mr. Mukesh Sakle', avatar:'DB'},
    { id: 2 , type:'Compiler Design', faculty:'Mr. Manjeet Kumar Soni', avatar:'CD'},
    { id: 3 , type:'Distributed Computing', faculty:'Mr. Vivek Menon', avatar:'DC'},
    { id: 4 , type:'System Software Laboratory', faculty:'Mr. Upendra Singh' , avatar:'SSL'},
    { id: 5 , type:'Advance Computer Network', faculty:'Dr. Mukul Shukla', avatar:'ACN'},
    { id: 6 , type:'Web Engineering', faculty:'Dr. Mukesh Sakle', avatar:'WE'},
]